import { render, staticRenderFns } from "./CourierList.vue?vue&type=template&id=96aae366&"
import script from "./CourierList.vue?vue&type=script&lang=js&"
export * from "./CourierList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports